<template>
  <section>
    <label>Categoria: </label>
    <span v-if="type == 'text'" v-b-tooltip.hover.right role="button" title="Clique para alterar a categoria"
      @click.prevent="$emit('resetCategoria')">
      <slot>nome da categoria</slot>
    </span>

    <div class="d-flex" v-else-if="type == 'select' && !!retultCategorias">
      <select name="categoria_id" v-if="categorias.length > 0" class="form-control" v-model="categoria_selecionada">
        <option :value="null">Selecione</option>
        <option v-for="categoria in categorias" :key="categoria.id" :value="categoria.id">
          {{ categoria.nome }}
        </option>
      </select>
      <b-btn variant="success" v-b-tooltip.hover.right title="Cadastrar categoria" @click.prevent="modalShow = true">
        <i class="fas fa-plus"></i>
        <span v-if="categorias.length == 0">Adicionar Categoria</span>
      </b-btn>
    </div>
    <b-modal id="modal-categoria" v-model="modalShow" max-width="300px" title="Cadastrar Categoria">
      <b-card>
        <b-card-text>
          <b-row>
            <b-col cols="12" sm="12" md="12">
              <label for="nome-categoria">Nome da Categoria</label>
              <b-form-input id="nome-categoria" v-model="categoria_nome" label="Nome da Categoria"></b-form-input>
            </b-col>
          </b-row>
        </b-card-text>
      </b-card>
      <template #modal-footer>
        <b-btn variant="outline-secondary" @click="modalShow = false">
          Fechar
        </b-btn>
        <b-btn variant="outline-secondary" :pressed="true" @click.prevent="add()" v-if="!!categoria_nome">
          Adicionar
        </b-btn>
      </template>
    </b-modal>
  </section>
</template>
<script>
export default {
  data() {
    return {
      categoria_selecionada: null,
      categorias: [],
      categoria_nome: "",
      modalShow: false,
      retultCategorias: false,
    };
  },
  props: {
    value: null,
    type: "",
  },
  watch: {
    value(newVal) {
      this.categoria_selecionada = newVal;
    },
    type: function (newValue) {

      if (newValue == "select") this.getCategorias();
    },
    categoria_selecionada(newVal) {
      this.$emit('input', newVal);
      this.$emit("setCategoria", this.categoria_selecionada);

    }
  },
  created() {
    this.$on("getCategorias", () => {
      this.getCategorias();
    });
  },
  mounted() {
    if (this.type == "select") {
      this.getCategorias();

    }
  },
  methods: {
    async getCategorias() {
      const result = await this.$api.get("tarefa/categorias");
      this.categorias = result.data;
      this.retultCategorias = true;
      // this.getSubCategorias();
      this.$emit("currentCategorias", this.categorias);
    },
    async add() {
      const response = await this.$api.post("tarefa/addCategoria", {
        categoria: this.categoria_nome,
      });
      this.modalShow = false;
      this.categoria_nome = "";

      if (response.data) {
        this.categorias.push(response.data);
        this.categoria_selecionada = response.data.id;
        this.$emit("setCategoria", response.data.id);
      }
    },
  },
};
</script>